import { AnimatePresence, motion } from 'framer-motion';
import { cn } from '@/utils/mergeClassName';

type ProgressBarProps = {
  enabled: boolean;
  totalItems: number;
  activeIndex: number;
  onNextSlide: () => void;
};
export const ProgressBar = ({
  enabled,
  totalItems,
  activeIndex,
  onNextSlide
}: ProgressBarProps) => {
  return (
    <div className="mt-2 flex h-0.5 w-full gap-[6px] ">
      <AnimatePresence>
        {Array.from({ length: totalItems }, (_, index) => {
          return (
            <motion.div
              className={cn(
                'w-20 bg-white opacity-60 transition-[width] duration-700 ease-in-out',
                index === activeIndex && 'w-full bg-white/[0.6] opacity-100'
              )}
              key={`progress-${activeIndex}-${index}`}
            >
              {index === activeIndex && (
                <motion.div
                  className="!h-0.5 !bg-white"
                  initial={{ width: '0%' }}
                  animate={
                    enabled
                      ? {
                          width: '100%',
                          transition: { duration: 6, ease: 'linear', delay: 0.2 }
                        }
                      : false
                  }
                  onAnimationComplete={onNextSlide}
                />
              )}
            </motion.div>
          );
        })}
      </AnimatePresence>
    </div>
  );
};
